/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const initialState = {
    treeCount: 0,
    firstName: '',
    lastName: '',
    email: '',
    permitPrice: 12,
    treeUnitPrice: 5,
    taxRate: 0.045,
    hasAgreed: false,
};

const fakeCartReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case 'ADD_TO_FAKE_CART':
            return {
                ...state,
                ...action.payload,
            };
        case 'CLEAR_FAKE_CART':
            return {
                ...state,
                ...initialState,
            };
        default:
            return state;
    }
};

export default fakeCartReducer;
